/* unplugin-vue-components disabled */import { render } from "./ArticleEdit.vue?vue&type=template&id=12350134&scoped=true"
import script from "./ArticleEdit.vue?vue&type=script&lang=js"
export * from "./ArticleEdit.vue?vue&type=script&lang=js"

import "./ArticleEdit.vue?vue&type=style&index=0&id=12350134&lang=less&scoped=true"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12350134"]])

export default __exports__